import { Injectable } from '@angular/core';
import jwt_decode from 'jwt-decode';
import { Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private readonly courseSubject = new Subject<any>();
  readonly serverSessionOut$: Observable<any> = this.courseSubject.asObservable();
  constructor() { }

  emitCourse(event: any): void {
    this.courseSubject.next(event);
  }
  getToken(): any {
    return localStorage.getItem('userToken');
  }

  setToken(token: string) {
    localStorage.setItem('access_token', token);
  }

  setRefreshToken(token: string) {
    localStorage.setItem('refresh_token', token);
  }
  getUser(): any {
    return localStorage.getItem('loginuser');
  }
  getRefreshToken(): any {
    return localStorage.getItem('refresh_token');
  }
  isTokenExpired(token:string) {
    console.log(JSON.parse(atob(token.split('.')[1])));
    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    return expiry * 1000 > Date.now();

  }

  clear() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('userToken');
    // Remove other session data as needed
  }


}
